import { render, staticRenderFns } from "./SitePrices.vue?vue&type=template&id=188038fc&scoped=true&"
import script from "./SitePrices.vue?vue&type=script&lang=js&"
export * from "./SitePrices.vue?vue&type=script&lang=js&"
import style0 from "./SitePrices.vue?vue&type=style&index=0&id=188038fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188038fc",
  null
  
)

export default component.exports